const BOOKING_URL = "https://api.leadconnectorhq.com/widget/booking/AK3IH1nwEwNhiDkL4Iak";

const particulares = {
  es: {
    locale: "es",
    phone: "+33756868432",
    phoneDisplay: "07 56 86 84 32",
    bookingUrl: BOOKING_URL,
    nav: {
      login: "Iniciar sesión",
      cta: "Contratar",
      langSwitcher: [],
    },
    hero: {
      title: "Protección total para tu vivienda de alquiler vacacional",
      subtitle: "Alquila tu casa con total tranquilidad por solo 0,82€ al día.",
      ctaPrimary: "Proteger mi vivienda",
      ctaCall: "Llamar al servicio",
    },
    compensations: {
      title: "Coberturas",
      items: [
        {
          title: "Vandalismo",
          amount: "50.000€",
          description: "Reembolso hasta 50.000€ por daños causados por huéspedes en tu vivienda.",
        },
        {
          title: "Chinches",
          amount: "10.000€",
          description: "Cobertura hasta 10.000€ en caso de chinches encontradas en tu vivienda.",
        },
        {
          title: "Reembolso exprés",
          amount: "48h máx",
          description: "Garantía de reembolso en 48h máximo directamente en tu cuenta bancaria.",
        },
      ],
    },
    fullCoverage: {
      title: "La protección más completa del mercado para tu vivienda vacacional.",
      cta: "Descubrir las garantías",
    },
    guarantees: {
      title: "Lo que HostProtect te garantiza",
      items: [
        {
          title: "Plagas",
          description: "Tratamiento de chinches, cucarachas u otras plagas. Gestión rápida y eficaz de tu vivienda.",
        },
        {
          title: "Vandalismo",
          description: "Reembolso por daños causados por huéspedes: muebles, paredes, equipamiento, hasta 50.000€.",
        },
        {
          title: "Realojamiento",
          description: "En caso de siniestro, tus huéspedes son realojados en hotel + comidas. Reembolso hasta 1.000€.",
        },
        {
          title: "Lucro cesante",
          description: "Si tu vivienda no está disponible, tu ingreso está protegido. Indemnización hasta 5.000€.",
        },
      ],
    },
    subscribeBanner: {
      title: "¡Contrata en solo 2 minutos!",
      cta: "Proteger mi vivienda",
    },
    useCases: {
      title: "¿Por qué no actuar ahora?",
      subtitle: "Tu segunda vivienda merece la mejor protección.",
      items: [
        {
          scenario: "Un grupo de fiesta destroza tu salón",
          consequence: "3.000€ en daños. Tu depósito de 500€ no cubre nada. Airbnb rechaza tu reclamación.",
          solution: "Con HostProtect: reembolso íntegro en 48h. Sin complicaciones.",
        },
        {
          scenario: "Chinches tras una estancia de verano",
          consequence: "Vivienda inutilizable 2 semanas en plena temporada. Pérdida de ingresos + coste del tratamiento.",
          solution: "Con HostProtect: tratamiento cubierto + lucro cesante indemnizado.",
        },
        {
          scenario: "Un huésped daña electrodomésticos y mobiliario",
          consequence: "1.500€ de reposición. Tu seguro del hogar no cubre daños por huéspedes de alquiler vacacional.",
          solution: "Con HostProtect: reembolso rápido con factura, franquicia del 10% del siniestro (mín. 150€).",
        },
      ],
    },
    testimonials: [
      {
        name: "Elena G.",
        role: "Propietaria en Marbella",
        text: "Alquilaba mi casa con miedo. Desde que tengo HostProtect, estoy tranquila. Un grupo destrozó el salón y me reembolsaron todo en 48 horas.",
        stars: 5,
      },
      {
        name: "Javier S.",
        role: "Propietario en Barcelona",
        text: "Mi seguro del hogar no cubría nada cuando un huésped causó daños. HostProtect sí. La diferencia es total.",
        stars: 5,
      },
      {
        name: "Lucía P.",
        role: "Propietaria en Madrid",
        text: "Chinches después de un alquiler de verano. 2.000€ de tratamiento cubiertos. Ningún otro seguro hace esto.",
        stars: 5,
      },
    ],
    video: {
      url: "",
      title: "Confían en nosotros",
      subtitle: "Descubre cómo protegen sus viviendas nuestros clientes.",
      fallbackText: "Vídeo testimonio próximamente",
    },
    pricing: {
      title: "HostProtect, precios claros y sin sorpresas",
      warning: "Protección diseñada para propietarios de viviendas vacacionales",
      plan: {
        price: "299,00€ HT",
        period: "+ IVA /año /vivienda",
        ctaPrimary: "Proteger mi vivienda",
        ctaVolume: "Tengo más de una vivienda",
        ctaCallback: "Quiero que me llamen",
        features: [
          { text: "Hasta 50.000€ de cobertura", highlight: true },
          { text: "Plagas y chinches cubiertos hasta 10.000€", highlight: true },
          { text: "Reembolso en 24 a 48h", highlight: true },
          { text: "Lucro cesante incluido", highlight: true },
          { text: "Gastos de realojamiento hasta 1.000€", highlight: true },
        ],
        note: "Franquicia del 10% del importe del siniestro (mínimo 150€) por siniestro. Sin depreciación aplicada.",
        priceNote: "Precio para suscripción anual, pago vía Stripe.",
      },
    },
    comparison: {
      titleHp: "Con HostProtect",
      titlePlatforms: "Sin HostProtect",
      hpFeatures: [
        "Cobertura total hasta 50.000€",
        "Plagas y chinches cubiertos hasta 10.000€",
        "Reembolso en 24 a 48h",
        "Lucro cesante incluido",
        "Gastos de realojamiento hasta 1.000€",
      ],
      platformDeficiencies: [
        "Tu seguro del hogar no cubre esto",
        "Airbnb cubre parcialmente",
        "Procedimientos largos e inciertos",
        "Ninguna indemnización por plagas",
        "Sin cobertura por lucro cesante",
        "Estás solo ante los daños",
      ],
    },
    volume: {
      title: "¿Tienes más de una vivienda?",
      description: "Nuestra oferta se adapta. Hablemos unos minutos para ofrecerte una propuesta a medida.",
      cta: "Reservar cita",
    },
    stats: {
      title: "Cifras 2024 de nuestros clientes",
      cta: "Quiero que me llamen",
      items: [
        { value: "10 000+", label: "propiedades aseguradas" },
        { value: "98%", label: "siniestros resueltos" },
      ],
    },
    faq: {
      title: "¿Tienes dudas?",
      subtitle: "Estas preguntas te ayudarán a decidir",
      bookingText: "Si necesitas más información, reserva una cita con nuestro equipo.",
      items: [
        {
          question: "¿Cuál es el importe de la franquicia?",
          answer: "10% del importe del siniestro, con un mínimo de 150€, independientemente del tipo de daño.",
        },
        {
          question: "¿Qué casos están excluidos?",
          answer: "Robo o desaparición de objetos, desgaste normal, daños intencionados, subarriendo o actividad prohibida.",
        },
        {
          question: "¿Los objetos de ocio están cubiertos?",
          answer: "Sí, hasta 1.000€ al año, siempre que estén a disposición de los huéspedes y mencionados en el anuncio.",
        },
        {
          question: "¿Cómo declarar un siniestro?",
          answer: "Inicia sesión, declara en 15 días, adjunta fotos y facturas. Indemnización en 24-48h tras validación.",
        },
      ],
    },
    finalCta: {
      title: "¿Listo para alquilar sin miedo?",
      subtitle: "Contrata en 2 minutos o reserva una cita con nuestro equipo.",
      ctaPrimary: "Proteger mi vivienda",
      ctaBooking: "Reservar cita",
      ctaCall: "Llamar al servicio",
    },
    footer: {
      rights: "© 2025 HostProtect. Todos los derechos reservados.",
      phone: "07 56 86 84 32",
    },
  },
};

export default particulares;
